
import React from 'react';
import { FlowRender } from "../flow-render";
import {RadioButton} from "../prm/radio-button";
import {Name} from "../prm/name";
import {Info} from "../../client/funcs/utils";

const tin_attestation = new RadioButton(
  new Name("tin_attestation"), [ new Name("yes", "The number entered on this application is my correct Taxpayer Identification Number.") ]);
tin_attestation.do_checkbox = true;;

const witholding_attestation = new RadioButton(
  new Name("witholding_attestation"), [ new Name("yes", "I am not subject to backup withholding due to a failure to report interest and dividend income.") ]);
witholding_attestation.do_checkbox = true;

const not_witholding_attestation = new RadioButton(
  new Name("not_witholding_attestation"), [ new Name("yes") ]);
not_witholding_attestation.do_checkbox = true;

const us_person_attestation = new RadioButton(
  new Name("us_person_attestation"), [ new Name("yes", "I am a U.S. person or a U.S. resident alien.") ]);
us_person_attestation.do_checkbox = true;

const facta_attestation = new RadioButton(
  new Name("facta_attestation"), [ new Name("yes", "The FACTA code entered on this form, if any, indicating that I am exempt from FACTA is correct.") ]);
facta_attestation.do_checkbox = true;

// const TEXT_0 = "The number entered on this application is my correct Taxpayer Identification Number.";
// const TEXT_1 = "I am not subject to backup withholding due to a failure to report interest "
//   + "and dividend income.";
// const TEXT_2 = "I am a U.S. person or a U.S. resident alien.";
// const TEXT_3 = "The FACTA code entered on this form, if any, indicating that I am exempt from "
//   + "FACTA is correct.";

const TEXT_1_ALT = "I have been notfiied by the IRS that I am currently subject to backup withholding "
  + "because I have failed to report all interest and dividends on my tax return.";

const FACTA_TEXT =
  "The Foreign Account Tax Compliance Act (FATCA) is a U.S. law aimed at preventing tax evasion by U.S. "
  + "taxpayers who hold financial assets outside the country. It requires foreign financial institutions "
  + "to report information about financial accounts held by U.S. taxpayers to the IRS. Additionally, U.S. "
  + "citizens and residents must report their foreign financial accounts and assets annually.";

class TaxAttestation extends FlowRender {

  constructor(index) {
    super(index, [
      tin_attestation,
      witholding_attestation,
      not_witholding_attestation,
      us_person_attestation,
      facta_attestation,
    ]);

    tin_attestation.onChangeCallback = this.onChange;
    witholding_attestation.onChangeCallback = this.onChange;
    not_witholding_attestation.onChangeCallback = this.onChange;
    us_person_attestation.onChangeCallback = this.onChange;
    facta_attestation.onChangeCallback = this.onChange;
  }

  init = (componentState, appState, component) => {
    super.init(componentState, appState, component);
    componentState.show_alt = not_witholding_attestation.isSelected(componentState, 0);
  }

  onChange = (component, new_state, prm) => {
    if (!prm) {
      return;
    }

    // Enforcing an XOR relationship between witholding_attestation and
    // not_witholding_attestation
    if (prm.name.id === witholding_attestation.name.id) {
      if (witholding_attestation.isSelected(new_state, 0)) {
        not_witholding_attestation.setValue(new_state, 0, false);
      }
    } else if (prm.name.id === not_witholding_attestation.name.id) {
      if (not_witholding_attestation.isSelected(new_state, 0)) {
        witholding_attestation.setValue(new_state, 0, false);
      }
    }
  }

  canNavigateNext = (component) => {
    const state = component.state;
    const orig_prms = [
      tin_attestation,
      witholding_attestation,
      us_person_attestation,
      facta_attestation,
    ];
    const highlight_rects = [];

    orig_prms.forEach(prm => {
      prm.isFilledElseHighlight(state, highlight_rects);
    });

    if (highlight_rects.length > 0) {
      // One of the required checkboxes are not checked.
      component.setState({ highlight_rects });
      return null;
    }

    if (not_witholding_attestation.isSelected(state, 0)
      || witholding_attestation.isSelected(state, 0)) {
      // All buttons are selected.
      return component.getRootUrl() + "/summary";
    }

    if (!state.show_alt) {
      component.setState({ show_alt: true});
      return null;
    }

    not_witholding_attestation.isFilledElseHighlight(state, highlight_rects);
    if (highlight_rects.length > 0) {
      component.setState({highlight_rects});
    }

    return null;
  }

  renderCheckboxText = (component, prm, text) => {
    const container_style = {
      display: "flex",
      paddingTop: "1rem",
      alignItems: "center",
    }
    return (
      <div style={container_style}>
        <div style={{ paddingRight: "1rem"}}>
          { prm.renderRadioLabelWithInfo(0, component, text) }
        </div>
        {/* <div style={{flex: "1"}}>
          {text}
        </div> */}
      </div>
    )
  }

  maybeRenderAlt = component => {
    const state = component.state;
    if (!state.show_alt) {
      return null;
    }
    return (
      <div style={{marginLeft: "2rem"}}>
        { this.renderCheckboxText(component, not_witholding_attestation, TEXT_1_ALT)}
      </div>
    )
  }
  renderBody = component => {
    const container_style = {
      marginLeft: "2rem",
    }

    const popup_style = {
      width: "40rem",
      border: "2px solid black",
      padding: "1rem",
    }
    const card = (
      <div style={{fontSize: "0.9rem"}}>
        <p>{FACTA_TEXT}</p>
      </div>
    )
    const info = (
      <Info
        id={"facta"}
        component={component}
        text={card}
        popup_style={popup_style}/>);

    return (
      <div>
        <div style={{ fontSize: "1.5rem"}}>I certify under penalty of perjury that:</div>
        <div style={container_style}>
          { this.renderCheckboxText(component, tin_attestation)}
          { this.renderCheckboxText(component, witholding_attestation)}
          { this.maybeRenderAlt(component)}
          { this.renderCheckboxText(component, us_person_attestation)}
          { this.renderCheckboxText(component, facta_attestation, info)}
        </div>
      </div>
    )
  }

  render = component => {
    return (
      <div>
        { this.renderHighlightRects(component) }
        { this.renderTitle(component, "Tax Attestation", "50%")}
        { this.renderProgress(component) }
        { this.renderSingleColumn(this.renderBody(component)) }
        { this.renderNextButtonRow(component, true) }
      </div>
    )
  }
}

export { TaxAttestation };
